import { ref } from 'vue'
import { defineStore } from 'pinia'
import { getUserInfo } from '@/api/app'
import Cookies from 'js-cookie'

export const useUserStore = defineStore('user', () => {
  const userInfo = ref(null)
  const isLogin = ref(Boolean(Cookies.get('tvbcoms')))

  const fetchUserInfo = async (_userInfo) => {
    if (userInfo.value) return userInfo.value
    if (Object.keys(_userInfo || {}).length > 0) {
      userInfo.value = _userInfo
      return userInfo.value
    }
    try {
      const { code, data, message } = await getUserInfo()
      if (code === 0) {
        userInfo.value = data
      } else throw Error({ code, data, message })
    } catch (error) {
      console.error(error)
    }
    return userInfo.value
  }

  return { userInfo, fetchUserInfo, isLogin }
})
